import dynamic from 'next/dynamic';
import { useResponsive } from '@/components/hooks/useResponsive';
import { seoSegmentationListingPage_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_caregiverSearchResults as CaregiverSearchResult } from '@/__generated__/seoSegmentationListingPage';
import { CaregiverSearchResultWithURL } from '@/types/SearchDirectory';

export interface CaregiverCardProps {
  searchResult: CaregiverSearchResult;
}

const CaregiverCardCompact = dynamic(() => {
  return import(
    '@/components/page/CaregiverSearchDirectory/components/CaregiverCard/CaregiverCardCompact'
  );
});

const CaregiverCardFull = dynamic(() => {
  return import(
    '@/components/page/CaregiverSearchDirectory/components/CaregiverCard/CaregiverCardFull'
  );
});

export const CaregiverCard = ({ searchResult }: CaregiverCardProps) => {
  const { isSmallViewport } = useResponsive();

  // Skip profiles without a URL
  if (searchResult.profileURL === null) return null;

  const validSearchResult: CaregiverSearchResultWithURL = {
    ...searchResult,
    profileURL: searchResult.profileURL,
  };

  if (isSmallViewport) return <CaregiverCardCompact searchResult={validSearchResult} />;
  return <CaregiverCardFull searchResult={validSearchResult} />;
};
